import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { NotificationEntity } from './notification.entity';
import { ObjectEntity } from './object.entity';

@Index('_fk__notification__id_latest', ['fkNotificationIdLatest'], {})
@Index('_fk__object__id', ['fkObjectId'], {})
@Index(
	'_type_fk__object__id__referencId_deleted_userId',
	['deletedUserId', 'type', 'fkObjectId', 'referenceId'],
	{},
)
@Entity('_notification_group')
export class NotificationGroupEntity extends BaseEntity {
	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('varchar', { name: '_type', length: 255 })
	public type!: string;

	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('int', { name: '_referenceId', nullable: true, unsigned: true })
	public referenceId!: number | null;

	@Column('tinyint', { name: '_public', unsigned: true, default: () => "'0'" })
	public public!: number;

	@Column('int', {
		name: '_fk__notification__id_latest',
		nullable: true,
		unsigned: true,
	})
	public fkNotificationIdLatest!: number | null;

	@OneToMany(
		() => NotificationEntity,
		(notification) => notification.fkNotificationGroupIdTo2,
		{},
	)
	public notifications!: Array<NotificationEntity>;

	@ManyToOne(() => ObjectEntity, (object) => object.notificationGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@ManyToOne(
		() => NotificationEntity,
		(notification) => notification.notificationGroups,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__notification__id_latest', referencedColumnName: 'id' },
	])
	public fkNotificationIdLatest2!: NotificationEntity;

	@OneToMany(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) => notificationGroupMember.fkNotificationGroup,
		{},
	)
	public notificationGroupMembers!: Array<NotificationGroupMemberEntity>;
}
